import { gql } from '@apollo/client';

export const HEATMAP_COORDINATES = gql`
  query FirstClickQuestionHeatmap($questionId: ID!, $segmentId: ID) {
    firstClickQuestionHeatmap(questionId: $questionId, segmentId: $segmentId) {
        id
        questionType
        questionOrder
        label
        image
        firstClickCoordinates {
            x,
            y
        }
    }
  }
`;
